// eslint-disable-next-line import/no-cycle
import api from '@src/api';
import { Observable } from 'rxjs';
import { Action } from 'redux-actions';

export const getApprovalCenter = (): Observable<Action> => (
	api.get('approval-center/')
);
